import { render, staticRenderFns } from "./DoKoDialogPlayers.vue?vue&type=template&id=e10aa348&scoped=true&"
import script from "./DoKoDialogPlayers.vue?vue&type=script&lang=ts&"
export * from "./DoKoDialogPlayers.vue?vue&type=script&lang=ts&"
import style0 from "./DoKoDialogPlayers.vue?vue&type=style&index=0&id=e10aa348&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e10aa348",
  null
  
)

export default component.exports